import { BuyButtonPosition } from '../constants/messaging'

type WantItemButtonExtra =
  | 'message'
  | 'buy'
  | 'item_reservation_request'
  | 'make_offer'
  | 'create_bundle'

type BuyerWantItemEventExtra = {
  item_id: number | null
  transaction_id: number | null
  button: WantItemButtonExtra
  global_search_session_id: string | null
  global_catalog_browse_session_id?: string | null
  search_session_id: string | null
  homepage_session_id?: string | null
}

type BuyerWantItemEventArgs = {
  transactionId: number | null
  itemId: number | null
  button: WantItemButtonExtra
  globalSearchSessionId: string | null
  globalCatalogBrowseSessionId?: string | null
  searchSessionId: string | null
  homepageSessionId?: string | null
}

export const buyerWantItemEvent = ({
  transactionId,
  itemId,
  button,
  globalSearchSessionId,
  globalCatalogBrowseSessionId,
  searchSessionId,
  homepageSessionId,
}: BuyerWantItemEventArgs) => {
  const extra: BuyerWantItemEventExtra = {
    button,
    item_id: itemId,
    transaction_id: transactionId,
    global_search_session_id: globalSearchSessionId,
    global_catalog_browse_session_id: globalCatalogBrowseSessionId || undefined,
    search_session_id: searchSessionId,
    homepage_session_id: homepageSessionId,
  }

  return {
    event: 'buyer.want_item',
    extra,
  }
}

type BuyerBuyEventArgs = {
  transactionId: number
  screen: string
  globalSearchSessionId?: string | null
  globalCatalogBrowseSessionId?: string | null
  homepageSessionId?: string | null
  sellerOfferId?: number
  buttonPosition?: BuyButtonPosition
}

type BuyerBuyEventExtra = {
  transaction_id: number
  screen: string
  global_search_session_id?: string | null
  global_catalog_browse_session_id?: string | null
  homepage_session_id?: string | null
  seller_offer_id?: number
  button_position?: BuyButtonPosition
}

export const buyerBuyEvent = (args: BuyerBuyEventArgs) => {
  const {
    transactionId,
    screen,
    globalSearchSessionId,
    globalCatalogBrowseSessionId,
    homepageSessionId,
    sellerOfferId,
    buttonPosition,
  } = args

  const extra: BuyerBuyEventExtra = {
    transaction_id: transactionId,
    screen,
    global_search_session_id: globalSearchSessionId,
    global_catalog_browse_session_id: globalCatalogBrowseSessionId,
    homepage_session_id: homepageSessionId,
    seller_offer_id: sellerOfferId,
    button_position: buttonPosition,
  }

  return {
    event: 'buyer.buy',
    extra,
  }
}
